<template>
  <div style="display: block; height: auto; overflow-y: auto">
      <table class="table table-sm table-borderless table-responsive">
          <thead>
          <tr>
              <th>ID</th>
              <th>{{ $t('material_station.material.material') }}</th>
              <th>{{ $t('material_station.material.type_test_code') }}</th>
              <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in selectedMaterials" :key="index">
              <td class="pt-2">{{ item.id }}</td>

              <td>
                  <select
                      v-model="item.material.id"
                      class="form-select form-select-sm"
                      :class="{ 'is-valid': item.material.id > 0 }"
                      :disabled="!isObserver && item.material.id > 0"
                      @change="updateModelValue"
                  >
                      <option :value="null" disabled>
                          {{ $t('material_station.material.select_material') }}
                      </option>
                      <option
                          v-for="material in materials"
                          :key="material.id"
                          :value="material.id"
                      >
                          {{ material.name }}
                      </option>
                  </select>
              </td>

              <td>
                  <input
                      v-model="item.type_test_code"
                      type="text"
                      class="form-control form-control-sm"
                      :class="{ 'is-valid': item.type_test_code?.length > 0 }"
                      @blur="updateModelValue"
                  />
              </td>

              <td class="text-center">
                  <i
                      class="fas fa-trash text-danger"
                      style="cursor: pointer; margin-top: .5em"
                      @click="removeItem(index)"
                  ></i>
              </td>
          </tr>
          </tbody>
      </table>
    <div class="button-container">
      <button
        class="btn btn-sm btn-outline-success form-button"
        @click.stop="addMaterial()"
      >
        <span>{{ $t('material_station.material.add_new') }}</span>
      </button>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";

export default {
    name: "MaterialList",
    mixins: [restApi],
    props: {
        modelValue: {
            type: Array,
            default() {
                return [];
            }
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        isWorker: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            materials: [],
            selectedMaterials: [],
            loading: false
        }
    },
    computed: {
        fields() {
            return [
                {
                    key: 'id',
                    label: this.$t('common.id'),
                    sortable: false
                },
                {
                    key: 'material',
                    label: this.$t('material_station.material.material'),
                    sortable: false
                },
                {
                    key: 'type_test_code',
                    label: this.$t('material_station.material.type_test_code'),
                    sortable: false
                },
                {
                    key: 'edit',
                    label: ''
                }
            ]
        }
    },
    created() {
        this.selectedMaterials = this.modelValue
        this.fetchMaterialTypes()
    },
    methods: {
        removeItem(index) {
            this.selectedMaterials.splice(index, 1)
            this.updateModelValue()
        },
        addMaterial() {
            this.selectedMaterials.push(this.newMaterial())
            this.updateModelValue()
        },
        updateModelValue() {
            this.$emit('update:modelValue', this.selectedMaterials)
        },
        fetchMaterialTypes: function () {
            this.loading = true
            this.restFetch(this.materialTypeUrl, this.success, this.fail)
        },
        success: function (response) {
            this.loading = false
            this.materials = response.data
        },
        fail: function () {
            this.loading = false
        },
        newMaterial: function () {
            return {
                material: {
                    id: null
                },
                type_test_code: ''
            }
        }
    }
}
</script>


<style scoped lang="scss">

</style>
